const checkBetaGroup = (
  BetaGroup: string[] | undefined,
  userEmail: string
): boolean =>
  BetaGroup &&
  userEmail &&
  BetaGroup.map((email: string) => email.toLowerCase()).includes(
    userEmail.toLowerCase()
  )
    ? true
    : false;

export default checkBetaGroup;
